import { useMemo } from 'react';
import { getConnectButtonDefaultIcon } from '../../../../../lib/connectButtons';
import styles from './QrConnectPreview.module.css';

export default function QrConnectPreview(props) {

    const { state } = props;
    const { header, buttons } = state;

    const headerReturn = useMemo(() => (
        <div 
            className={styles.header} 
            style={{
                backgroundColor: header.background, 
                backgroundImage: header.use_image ? `url(${header.image})` : 'none', 
                color: header.color
            }}>
            {!header.hide_text && `${header.text ? header.text : 'Header'}`}
        </div>
    ),[header]);

    const buttonsReturn = useMemo(() => (
        <div className={styles.buttons}>
            {buttons.map((button) => {
                const icon = button.icon || getConnectButtonDefaultIcon(button);
                return (
                <div 
                    className={styles.button} 
                    key={button.id}
                    style={{
                        backgroundColor: button.background,
                        color: button.color,
                        borderWidth: `${(button.border?.width || 1) / 2}px`,
                        borderStyle: button.border?.style || 'none',
                        borderColor: button.border?.color || '#dddddd',
                        borderRadius: `${(button.border?.radius || 8) / 2}px`,
                        boxShadow: `${(button.box_shadow?.x || 0) / 2}px ${(button.box_shadow?.y || 1) / 2}px ${(button.box_shadow?.blur || 3) / 2}px ${button.box_shadow?.color || '#dddddd'}` || '0 1px 3px rgba(0,0,0,.2)'
                    }}
                >
                    {(button.type !== 'continue') && (<i className={icon} style={{position: 'absolute', left: '.5rem', width: 'fit-content'}} />)}
                    <div><span>{button.text}</span>{(button.type === 'continue') && (<i className={icon} style={{width: 'fit-content'}} />)}</div>
                </div>
                );
            })}
        </div>
    ),[buttons]);

    return (
        <div className={styles.container}>
            <div className={styles.phone} style={{backgroundImage: `url('/images/iPhone.png')`}}>
                <div className={styles.top}>
                    <div className={styles.topInfo}>
                        <div>12:34</div>
                        <div>
                            <i className='far fa-signal' />
                            <i className='far fa-wifi' />
                            <i className='far fa-battery' />
                        </div>
                    </div>
                    <div className={styles.topUrl}>app.liquidqr.com</div>
                </div>
                <div className={styles.middle}>
                    {headerReturn}
                    {buttonsReturn}
                    {/* header and buttons go here */}
                </div>
                <div className={styles.bottom}>
                    <span><i className='far fa-arrow-left' /></span>
                    <span><i className='far fa-arrow-right' /></span>
                    <span><i className='far fa-plus' /></span>
                    <span><i className='far fa-square-1' /></span>
                    <span><i className='far fa-ellipsis' /></span>
                </div>
            </div>
        </div>
    )
}